import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ReplaySubject, Subject } from 'rxjs';
import { ENTER } from '@angular/cdk/keycodes';
import { debounceTime } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { CommonModelService } from '../../../../../padu-reporting/capability/common-model.service';
import { MaintenanceService } from '../../../../../techopsv4/services/maintenanceService';

@Component({
    selector: 'app-add-segment',
    templateUrl: './add-segment.component.html',
    styleUrl: './add-segment.component.css',
    standalone: false
})
export class AddSegmentComponent {
  
  @Input() isAddSegment;

  @Output() SegmentAdded: EventEmitter<any> = new EventEmitter();

  @ViewChild('inputAddOwner') inputAddOwner: any;
  @ViewChild('inputAddDelegate') inputAddDelegate: any;

  private subject: Subject<string> = new Subject();
  destroy$: ReplaySubject<boolean> = new ReplaySubject(1);

  inputElement: any;
  users: any = [];
  separatorKeysCodes: number[] = [ENTER];
  AddSegmentUpdate = {
    'FundingOwner': [],
    'FundingSegment': [],
  };
  disableEdit: boolean = true;
  fundingSegment: any = '';
  userRole: any;
  fundingSourceDropdownList: any;
  fundingSourceSelected: any;

  constructor(
    public dialog: MatDialog,
    private capabilityService: CommonModelService,
    private toastrService: ToastrService,
    private maintemceService: MaintenanceService) { }

  ngOnInit(): void {
    this.fundingSourceDropdownList = [{name: 'UHC'}, {name: 'Tech Forward'}, {name: 'Other OT'}];
    this.fundingSourceSelected = {name: 'UHC'};
    this.subject.pipe(
      debounceTime(500)
    ).subscribe(searchObj => {
      this.handleSearch(searchObj);
    });
  }

  ngOnChanges() {
    this.subject.pipe(
      debounceTime(500)
    ).subscribe(searchObj => {
      this.handleSearch(searchObj);
    });
  }

  removeOwnerAndDeligate(user, role) {
    if (role === 'Funding_Owner') {
      const index = this.AddSegmentUpdate.FundingOwner.indexOf(user);
      if (index >= 0) {
        this.AddSegmentUpdate.FundingOwner.splice(index, 1);
      }
      this.disableAddSegment();
    }
    else {
      const index = this.AddSegmentUpdate.FundingSegment.indexOf(user);
      if (index >= 0) {
        this.AddSegmentUpdate.FundingSegment.splice(index, 1);
      }
      this.disableAddSegment();
    }
  }

  keyUpSearch(name) {
    const p: any = {}
    p['search'] = name.target.value;
    this.inputElement = name;
    if (name.target.value) {
      this.subject.next(p);
    }
    else {
      this.users = [];
    }
  }

  AddFundingOwner(event, role) {
    if (event.option.value.givenName !== '') {
      if (role === 'Funding_Owner') {
        this.userRole = role;
        this.AddSegmentUpdate.FundingOwner.push({
          givenName: event.option.value.givenName,
          sn: event.option.value.sn,
          mail: event.option.value.mail,
          displayName: event.option.value.displayName,
          employeeID: event.option.value.employeeID,
          msid: event.option.value.msid,
          middleName: event.option.value.sn,
          User_Role: this.userRole
        });
        this.disableAddSegment();
      }
      else if (role === 'Funding_Delegate') {
        this.userRole = role;
        this.AddSegmentUpdate.FundingSegment.push({
          givenName: event.option.value.givenName,
          sn: event.option.value.sn,
          mail: event.option.value.mail,
          displayName: event.option.value.displayName,
          employeeID: event.option.value.employeeID,
          msid: event.option.value.msid,
          middleName: event.option.value.sn,
          User_Role: this.userRole
        });
        this.disableAddSegment();
      }
    }
    if (this.inputElement) {
      this.inputElement.target.value = '';
      this.users = []
    }
  }

  checkExistUser(user, type, actionType) {
    let tempVar = [];
    if (actionType === 'Add') {
      if (type === 'Funding_Owner') {
        tempVar = this.AddSegmentUpdate.FundingOwner;
      }
      else {
        tempVar = this.AddSegmentUpdate.FundingSegment;
      }
    }
    let tempBool = false
    tempVar.forEach(archi => {
      if (user.msid === archi.msid) {
        tempBool = true;
      }
    });
    return tempBool;
  }

  handleSearch(searchObj) {
    const value = searchObj['search'];
    const column = searchObj['column'];
    console.log('Column', column);
    if (value) {
      this.capabilityService.getLDAPUsers(value).subscribe(dataStream => {
        this.users = [];
        dataStream.forEach(element => {
          this.users.push({
            givenName: element.givenName,
            sn: element.sn,
            mail: element.mail,
            displayName: element.displayName,
            employeeID: element.employeeID,
            msid: element.cn,
            middleName: element.middleName,
          });
        });
      }, (error) => {
        console.error(error);
        const errorMessage = error?.error?.message ? error?.error?.message:'Internal Server Error';
        this.toastrService.error(errorMessage, '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      });
    } else {
      column.options = [];
    }
  }

  addSegment() {
    const addSegmentPayload = {
      "Funding_Source": this.fundingSourceSelected.name,
      "Funding_Segment": this.fundingSegment.trim(),
      "Funding_Owner": this.AddSegmentUpdate.FundingOwner,
      "Funding_Delegate": this.AddSegmentUpdate.FundingSegment
    }
    this.maintemceService.insertSegment(addSegmentPayload).subscribe((data: any) => {
      console.log('Status Data:', data);
      if (Object.keys(data).length === 0) {
        this.toastrService.success('Segment Added Successfully', '', {
          timeOut: 10000,
          positionClass: 'toast-top-center'
        });
        this.SegmentAdded.emit('true');
      }
    }, (error) => {
      console.log('error:', error);
      this.toastrService.error(error?.error?.message, '', {
        timeOut: 5000,
        positionClass: 'toast-top-center'
      });
    })
  }

  disableAddSegment() {
    if (this.fundingSegment.trim() === '') {
      return this.disableEdit = true;
    }  else {
      return this.disableEdit = false;
    }
  }

  focusOnInput(type) {
    if (type === 'addOwner') {
      this.inputAddOwner.nativeElement.focus();
    }
    else if (type === 'addDelegate') {
      this.inputAddDelegate.nativeElement.focus();
    }
  }

  onFundingSegmentChange(ev:any){
    if(ev.value)
      this.fundingSourceSelected = {name : ev.value };
    else
      this.fundingSourceSelected = this.fundingSourceDropdownList[0];
  }
}  
